import { useWindowSize } from 'common/utils/style.util';
import { generateMedia } from 'styled-media-query';

export const BREAKPOINTS = {
  large: 1920,
  desktop: 1400,
  tablet: 1024,
  mobileL: 768,
  mobile: 320,
};

export const BREAKPOINT_PIXELS = Object.entries(BREAKPOINTS).reduce(
  (a, b) => ({
    ...a,
    [b[0]]: `${b[1]}px`,
  }),
  {},
);

const customMedia = generateMedia(BREAKPOINT_PIXELS);

export default customMedia;

export const MobileView = ({ threshold = 1024, isMobile, children }) => {
  const { width } = useWindowSize();
  return (isMobile || width <= threshold) && children;
};

export const DesktopView = ({ threshold = 1024, isMobile, children }) => {
  const { width } = useWindowSize();
  return (isMobile || width > threshold) && children;
};
